import axios from "@/api/axiosAuthRequired.js"
import { BASE_URL } from "@/constants/util"

export const fetchPgGames = async () => {
  try {
    const url = `${BASE_URL}pg-resources/games`
    const res = await axios.get(url)
    return res.data
  } catch (error) {
    return null
  }
}

export const fetchInstaproGames = async () => {
  try {
    const url = `${BASE_URL}instapro/games`
    const res = await axios.get(url)
    return res.data
  } catch (error) {
    return null
  }
}



// WEBPACK FOOTER //
// ./src/store/game/game.apis.js